import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { IUser } from 'app/shared/model/user.model';
import { IInspection } from 'app/shared/model/inspection.model';
import { IInspectionItemPerformed } from 'app/shared/model/inspection-item-performed.model';
import { InspectionStatus } from 'app/shared/model/enumerations/inspection-status.model';

export interface IInspectionHistory {
  id?: number;
  created?: string | null;
  status?: InspectionStatus | null;
  truckImplement?: ITruckImplement | null;
  user?: IUser | null;
  inspection?: IInspection | null;
  inspectionItemPerformeds?: IInspectionItemPerformed[] | null;
  observations?: string | null;
}

export const defaultValue: Readonly<IInspectionHistory> = {};
